import React from 'react';
import {Helmet} from 'react-helmet';
import {
    Col,
    Grid,
    Row
} from 'react-flexbox-grid';

import Nameplate from '../components/splash/nameplate'
import MissionStatement from '../components/splash/mission-statement'
import AppDetails from '../components/splash/app-details'
import Highlights from '../components/splash/highlights'
import Emerson from '../components/splash/emerson'
import Articles from '../components/splash/articles'

import CalltoAction from '../components/splash/call-to-action'

export default class IndexPage extends React.Component{
    constructor(props){
	super();
    }
    
    render(){
	var data = this.props.data;
	return(
	    <div style={this.props.transition && this.props.transition.style}>
		<Nameplate
		    imgs={{
			logo:{
			    white: data.logo_white
			}
		    }}
		/>
		<CalltoAction />
		<MissionStatement
		    imgs={{
			sharing_food: data.sharing_food
		    }}
		/>
		<AppDetails
		    imgs={{
			phone: data.phone,
			 badge:{
			     browser: data.badge_browser,
			     google: data.badge_google,
			     ios: data.badge_ios
			 }
		    }}
		/>
		<Highlights content={data.highlights} />
		<Emerson />
		<Articles content={data.articles} />
		</div>
	)
    }
}


export const query = graphql`
query indexQuery{
    logo_white: file(relativePath:{ eq: "assets/img/logo/white-nameplate.png"}){
	childImageSharp{
        sizes(
	    quality: 100
	){
            ...GatsbyImageSharpSizes_tracedSVG
        }
      }
    }
    sharing_food: file(relativePath:{ eq: "components/splash/mission-statement/sharing_food.jpg"}){
	childImageSharp{
        sizes(
            maxWidth: 500,
        ){
            ...GatsbyImageSharpSizes
        }
      }
    },
    phone: file(relativePath:{ eq: "components/splash/app-details/phone-rotated.png"}){
	childImageSharp{
        sizes(
	    maxWidth: 500,
        ){
            ...GatsbyImageSharpSizes
        }
      }
    },
    badge_browser: file(relativePath:{ eq: "components/splash/app-details/badge-browser.png"}){
	childImageSharp{
        sizes(
            maxWidth: 500
        ){
            ...GatsbyImageSharpSizes
        }
      }
    },
    badge_google: file(relativePath:{ eq: "components/splash/app-details/badge-google.png"}){
	childImageSharp{
        sizes(
            maxWidth: 500,
        ){
            ...GatsbyImageSharpSizes
        }
      }
    },
    badge_ios: file(relativePath:{ eq: "components/splash/app-details/badge-ios.png"}){
	childImageSharp{
        sizes(
            maxWidth: 500,
        ){
            ...GatsbyImageSharpSizes
        }
      }
    },
    highlights: allMarkdownRemark
    (filter: {fileAbsolutePath: {regex: "/components\/splash\/highlights\\/md\\/[a-zA-Z-_0-9]*\\.md$/"}},
	sort: { fields: [frontmatter___order], order: ASC }
    )
    {
        edges {
            node{
		html
                frontmatter{
		    title
		}
            }
        }
    },
    articles: allMarkdownRemark
    (filter: {fileAbsolutePath: {regex: "/articles\\/[a-zA-Z-_0-9]*\\/[a-zA-Z-_0-9]*\\.md$/"}},
	sort: { fields: [frontmatter___date], order: DESC }
    )
    {
        edges {
            node{
		html
		excerpt
		fields{
		    slug
		}
                frontmatter{
		    title
		    subtitle
		    date
		}
            }
        }
    }

}
`



// WEBPACK FOOTER //
// ./src/pages/index.js